export default () => {
  initHeaderNav();

  function initHeaderNav() {
    const mobileView = window.matchMedia('(max-width: 992px)');
    const touchDeviceInDesktopView =
      window.matchMedia('(min-width: 992px)').matches &&
      ('ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0);
    const $headerNav = $('.header-nav');
    const $navItemLinksAll = $('.header-nav__content ul > li > .header-nav__link');
    const $navItemLinksWithCollapse = $('.header-nav__content ul > li > *[data-target]');
    const $navItemLinksWithOnlyTeaserCollapse = $navItemLinksWithCollapse.filter('[data-only-teaser-content]');
    const $navItemLinksWithOnlyMenuListCollapse = $navItemLinksWithCollapse.filter(':not([data-only-teaser-content])');
    const $navContents = $('.header-nav__content');
    const $navContentLvl1 = $('.header-nav__content-lvl-1');
    const $header = $('.header') ? $('.header') : $('.apn-header');
    const $backdrop = $('.backdrop');

    setViewConfig();
    window.onresize = setViewConfig;
    initNavMobile();
    initNavDesktop();

    /**
     * set view specific config
     */
    function setViewConfig() {
      if (mobileView.matches) {
        // close layer on change view
        $navContentLvl1.trigger('mouseleave');
        // remove height. It set for desktop view
        $navContents.filter(':not(.header-nav__content-lvl-1)').height('');
        // remove all _js_link64 class to set mobile view specific to enable click action for fake-link in leaflet.js
        $navItemLinksAll.filter('[data-nav-fake-link]').removeClass('_js_link64');
        $navItemLinksWithOnlyTeaserCollapse.filter('[data-nav-fake-link]').addClass('_js_link64');
        $navItemLinksAll.filter('[data-nav-fake-link]:not([data-target])').addClass('_js_link64');
        // accessibility
        $navItemLinksWithOnlyTeaserCollapse.removeAttr('role');
        $navItemLinksWithOnlyTeaserCollapse.removeAttr('aria-expanded');
      } else {
        // close mobile navi
        $('.js-toggle-off-canvas').removeClass('collapsed');
        $('.js-toggle-off-canvas').attr('aria-expanded', 'false');
        $navContentLvl1.removeClass('show');
        $('body').toggleClass('backdrop-visible');
        // remove height. It set for mobile view
        $navContents.height('');
        $navContents.find('> ul').height('');
        // accessibility
        $navItemLinksWithOnlyTeaserCollapse.attr('role', 'button');
        $navItemLinksWithOnlyTeaserCollapse.attr('aria-expanded', 'false');
        // add class _js_link64 to enable click action for fake-link in leaflet.js
        $navItemLinksAll.filter('[data-nav-fake-link]').addClass('_js_link64');
        //hide backdrop and opened nav desktop
        _toggleBackdropDesktop(false);
        $navContentLvl1.find('> ul > li > *[aria-expanded="true"]').attr('aria-expanded', 'false');
      }
    }

    /**
     * navi mobile view
     */
    function initNavMobile() {
      // switch toogler & show/close navi (level 1)
      $('.js-toggle-off-canvas').on('click touch', function () {
        if (mobileView.matches === false) return;
        $(this).toggleClass('collapsed');
        $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
        $navContentLvl1.toggleClass('show');
        if ($navContentLvl1.hasClass('show')) {
          setNavContentInnerHeight($navContentLvl1);
          $navItemLinksAll.filter('[aria-expanded="true"]').attr('aria-expanded', 'false');
        }
        $('body').toggleClass('backdrop-visible');
        // set height to level 1 nav content (outer height for scroll). + 1px rounding error
        $navContentLvl1.css('height', 'calc(100vh - ' + ($header.outerHeight() - 1) + 'px)');
        $navContentLvl1.scrollTop(0);
      });

      // show level 2 & 3
      $navItemLinksWithOnlyMenuListCollapse.on('click touch', function (e) {
        if (mobileView.matches === false) return;
        const $contentLvlToShow = $($(this).data('target'));
        if ($contentLvlToShow) {
          e.preventDefault();
          // hide all visible content of current level & show selected
          const $currentContent = $(this).closest('.header-nav__content');
          $currentContent.find('> ul > li > *[aria-expanded="true"]').attr('aria-expanded', 'false');

          $(this).attr('aria-expanded', 'true');
          setNavContentInnerHeight($contentLvlToShow);

          $navContentLvl1.scrollTop(0);
          $currentContent.scrollTop(0);
        }
      });

      // close level 1 & 2 & 3
      $headerNav.find('.header-nav__back-link').on('click touch', function () {
        if (mobileView.matches === false) return;
        const $navContent = $(this).closest('.header-nav__content');
        if ($navContent.hasClass('header-nav__content-lvl-1')) {
          // close level 1
          $('.js-toggle-off-canvas').trigger('click');
        } else {
          // close level 2 & 3
          $navContent.siblings('*[aria-expanded="true"]').attr('aria-expanded', 'false');
          setNavContentInnerHeight($navContent.parent().closest('.header-nav__content'));
        }
      });

      /**
       * set height for ul-element in all contents to height of visible nav-content (or window height if smaller) for mobile view to enable scroll
       * use on each change visible nav-content level
       * @param $visibleNavContent
       */
      function setNavContentInnerHeight($visibleNavContent) {
        const $navInnerContents = $('.header-nav__content > ul');
        const $visibleNavInnerContent = $visibleNavContent.find('> ul');
        const naviMaxHeight = $(window).height() - $header.outerHeight();

        $visibleNavInnerContent.height('');
        if (naviMaxHeight < $visibleNavInnerContent.height()) {
          $navInnerContents.height($visibleNavInnerContent.height());
        } else {
          $navInnerContents.height(naviMaxHeight);
        }

        // Set height on the panel container to activate overflow-y: auto scrolling on lvl-2/3
        $visibleNavContent.css('height', 'calc(100vh - ' + ($header.outerHeight() - 1) + 'px)');
      }
    }

    /**
     * navi desktop view
     */
    function initNavDesktop() {
      let navContentShowTimeoutId;
      let navContentShowTimeoutDelay;
      let navContentHideTimeoutId;
      let navContentHideBackdropTimeoutId;
      const navContentHideTimeoutDelay = 300;

      // all level: hide/show nav content on mouseover for desktop and touchstart for mobile
      $navItemLinksAll.on('touchstart mouseover showWithoutDelay', function (e) {
        if (mobileView.matches === true) return;
        navContentShowTimeoutDelay = e.type === 'showWithoutDelay' ? 0 : 300;
        const $navItemLink = $(this);

        clearTimeout(navContentShowTimeoutId);
        if ($navItemLink.hasClass('header-nav__lvl-headline')) return;

        // for desktop touch: prevent a-href request and open level 1(layer).
        if (
          touchDeviceInDesktopView &&
          $navItemLink.data('target') &&
          $navItemLink.data('level') === 1 &&
          e.type === 'touchstart'
        ) {
          e.preventDefault();
          if ($navItemLink.attr('aria-expanded') === 'true') {
            // close layer if opened
            $navContentLvl1.trigger('mouseleave');
            return;
          }
        }

        navContentShowTimeoutId = setTimeout(function () {
          // hide all visible content form this level and down
          $navItemLink
            .closest('.header-nav__content')
            .find('ul > li > *[aria-expanded="true"]')
            .attr('aria-expanded', 'false');

          if ($navItemLink.data('target')) {
            if ($navItemLink.data('level') === 1) {
              // open level-3 content from first link-item with content on open level-2(layer)
              $($navItemLink.data('target'))
                .find('> ul > li > *[aria-expanded="false"]')
                .first()
                .trigger('showWithoutDelay');
            }

            // show nav content
            $navItemLink.attr('aria-expanded', 'true');
            setLayerHeightForSelectedNavLinkItem($navItemLink);
            _toggleBackdropDesktop(true);

            const lazyloadImages = $($navItemLink.data('target')).find('> .header-nav__teaser img.lazyload');
            if (lazyloadImages.length > 0) {
              // repeat set height for lazyload images, because loading change the element height
              onClassChange(lazyloadImages.get(0), function () {
                setLayerHeightForSelectedNavLinkItem($navItemLink);
              });
            }
          }
        }, navContentShowTimeoutDelay);
      });

      // prevent adding following event listeners on mobile
      if (mobileView.matches === true) return;

      // hide all expanded levels on mouseleave of level 1(layer)
      $navContentLvl1.on('mouseleave', function (e) {
        const contentLvl1 = $(this);
        navContentHideTimeoutId = setTimeout(function () {
          contentLvl1.find('> ul > li > *[aria-expanded="true"]').attr('aria-expanded', 'false');
          _toggleBackdropDesktop(false);
        }, navContentShowTimeoutDelay);
      });

      // close backdrop on touch on large mobile devices
      $backdrop.on('touchstart', function (e) {
        $navContentLvl1.find('> ul > li > *[aria-expanded="true"]').attr('aria-expanded', 'false');
        _toggleBackdropDesktop(false);
      });

      // close backdrop and nav content on links without dropdown
      $('.header-nav__content-lvl-1 > ul > li > .header-nav__link:not([aria-haspopup="menu"])').on(
        'mouseenter',
        function (e) {
          const contentLvl1 = $(this);
          navContentHideBackdropTimeoutId = setTimeout(function () {
            contentLvl1.find('> ul > li > *[aria-expanded="true"]').attr('aria-expanded', 'false');
            _toggleBackdropDesktop(false);
          }, navContentShowTimeoutDelay);
        },
      );

      $('.header-nav__content-lvl-2').on('mouseenter', function (e) {
        // stop layer-close action on hover the layer
        clearTimeout(navContentHideTimeoutId);
      });

      /**
       *  set layer height => some height of level 2 & 3 & 4
       *
       * @param $navItemLink
       */
      function setLayerHeightForSelectedNavLinkItem($navItemLink) {
        let $navContents = $($navItemLink.data('target'));
        $navContents = $navContents.add($navItemLink.parents('.header-nav__content:not(.header-nav__content-lvl-1)'));
        $navContents.height('');

        let navContentLayerHeight = 0;
        $navContents.each(function () {
          if (navContentLayerHeight < $(this).outerHeight()) {
            navContentLayerHeight = $(this).outerHeight();
          }
        });
        $navContents.css('height', navContentLayerHeight + 'px');
      }
    }

    function _toggleBackdropDesktop(isVisible) {
      if (!$backdrop.length) return;
      if (isVisible) {
        $('body').addClass('backdrop-visible');
      } else {
        $('body').removeClass('backdrop-visible');
      }
    }
  }

  /**
   *
   * @param node
   * @param callback
   * @returns {MutationObserver}
   */
  function onClassChange(node, callback) {
    let lastClassString = node.classList.toString();

    const mutationObserver = new MutationObserver((mutationList) => {
      for (const item of mutationList) {
        if (item.attributeName === 'class') {
          const classString = node.classList.toString();
          if (classString !== lastClassString) {
            callback(mutationObserver);
            lastClassString = classString;
            break;
          }
        }
      }
    });

    mutationObserver.observe(node, { attributes: true });
    return mutationObserver;
  }
};
